import { PageOptions } from './../../../../shared/data-table/data-table.interface';
import { BaseHttpService } from './../../../../shared/base-http/base-http.service';
import { Injectable } from '@angular/core';
import { config } from 'src/config/config';
import { getEnv } from 'src/modules/utility';

@Injectable({
  providedIn: 'root'
})
export class ChangeLogModalService {

  constructor(
    private readonly http: BaseHttpService
  ) { }

  getChangeLogs(page: PageOptions) {
    const url = `${config.tprecmApiBaseUrl[getEnv()]}maint/change-log?page=${page.page}&sort=${page.sort}&order=${page.order}&size=${page.size}`;
    return this.http.get(url);
  }

  addChangeLog(data: any) {
    const url = `${config.tprecmApiBaseUrl[getEnv()]}maint/change-log`;
    return this.http.post(url, data);
  }

  editChangeLog(data: any) {
    const url = `${config.tprecmApiBaseUrl[getEnv()]}maint/change-log`;
    return this.http.put(url, data);
  }

  deleteChangeLog(id: number) {
    const url = `${config.tprecmApiBaseUrl[getEnv()]}maint/change-log/${id}`;
    return this.http.delete(url);
  }
}
